import * as React from 'react';

type IconAnalisisProps = React.SVGProps<SVGSVGElement>;

export const IconAnalisis: React.FC<IconAnalisisProps> = (props) => (
	<svg
		width={31}
		height={30}
		viewBox="0 0 31 30"
		fill="none"
		xmlns="http://www.w3.org/2000/svg"
		{...props}>
		<path
			d="M28 15.5166C28 18.5375 27.0229 21.4773 25.2145 23.8972C23.4062 26.317 20.8637 28.087 17.9666 28.9429C15.0695 29.7988 11.9732 29.6947 9.1402 28.646C6.30716 27.5974 3.88931 25.6605 2.24766 23.1247C0.606014 20.5888 -0.17135 17.5899 0.0316434 14.5758C0.234636 11.5618 1.4071 8.69425 3.37395 6.40139C5.34081 4.10853 7.99654 2.51336 10.9446 1.85408C13.8927 1.19479 16.9749 1.50676 19.7311 2.74339L14 15.5166L28 15.5166Z"
			fill="#EBF8F0"
		/>
		<path
			d="M28 15.5166C28 17.3551 27.6379 19.1756 26.9343 20.8742C26.2307 22.5727 25.1995 24.1161 23.8995 25.4161L14 15.5166H28Z"
			fill="#7EAE90"
		/>
		<path
			d="M22.7489 1.68503C24.87 2.95949 26.6659 4.70951 27.9949 6.79697C29.3238 8.88443 30.1494 11.2522 30.4064 13.7134L17.2548 13.7134L22.7489 1.68503Z"
			fill="#FFA692"
		/>
	</svg>
);
